interface State {
  dataSource: any[]
  isAddModalVisivle: boolean
  selectedRowKeys: any[]
  invoiceData: any[] // 开票信息
  formData: any
  isSubmitButtonLoading: boolean
  isSubmitFailure: boolean
  isDisabledSubmit: boolean
  submitFailInfo: {
    applyAmount?: number // 本次申请付款金额
    countAmount?: number // 总应付金额
    countApplyAmount?: number // 申请付款中金额
    time?: string
  }
}
type ActionType =
  | 'setDataSource'
  | 'setSelectedRowKeys'
  | 'setIsAddModalVisivle'
  | 'setInvoiceData'
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setIsSubmitButtonLoadingAction'
  | 'setIsSubmitFailure'
  | 'setIsDisabledSubmit'
  | 'setSubmitFailInfo'
  | 'reloadStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  dataSource: [],
  isAddModalVisivle: false,
  selectedRowKeys: [],
  invoiceData: [],
  formData: {},
  isSubmitButtonLoading: false,
  isSubmitFailure: false,
  isDisabledSubmit: false,
  submitFailInfo: {},
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setIsAddModalVisivle':
      newstate.isAddModalVisivle = action.payload
      return newstate
    case 'setInvoiceData':
      newstate.invoiceData = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    case 'setIsSubmitFailure':
      newstate.isSubmitFailure = action.payload
      return newstate
    case 'setIsDisabledSubmit':
      newstate.isDisabledSubmit = action.payload
      return newstate
    case 'setSubmitFailInfo':
      newstate.submitFailInfo = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置添加订单弹窗显示
 * @param val
 * @returns
 */
export const setIsAddModalVisivle = (val: any): Action => ({
  type: 'setIsAddModalVisivle',
  payload: val,
})

/**
 * 设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSource = (val: any): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowKeys = (val: any): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})

/**
 * 设置开票信息数据
 * @param val
 * @returns
 */
export const setInvoiceData = (val: any[]): Action => ({
  type: 'setInvoiceData',
  payload: val,
})
/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})

/**
 * 提交按钮防重处理
 * @param val
 * @returns
 */
export const setIsSubmitButtonLoadingAction = (val: boolean): Action => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})

/**
 * 提交失败
 * @param val
 * @returns
 */
export const setIsSubmitFailure = (val: boolean): Action => ({
  type: 'setIsSubmitFailure',
  payload: val,
})

/**
 * 禁用提交按钮
 * @param val
 * @returns
 */
export const setIsDisabledSubmit = (val: boolean): Action => ({
  type: 'setIsDisabledSubmit',
  payload: val,
})

/**
 * 提交失败提示信息
 * @param val
 * @returns
 */
export const setSubmitFailInfo = (val: {
  applyAmount?: number
  countAmount?: number
  countApplyAmount?: number
  time?: string
}): Action => ({
  type: 'setSubmitFailInfo',
  payload: val,
})

// 重载数据
export const reloadStateAction = (val: State): Action => ({
  type: 'reloadStateAction',
  payload: val,
})
interface State {
  dataSource: any[]
  isAddModalVisivle: boolean
  selectedRowKeys: any[]
  invoiceData: any[] // 开票信息
  formData: any
  isSubmitButtonLoading: boolean
  isSubmitFailure: boolean
  isDisabledSubmit: boolean
  submitFailInfo: {
    applyAmount?: number // 本次申请付款金额
    countAmount?: number // 总应付金额
    countApplyAmount?: number // 申请付款中金额
    time?: string
  }
}
type ActionType =
  | 'setDataSource'
  | 'setSelectedRowKeys'
  | 'setIsAddModalVisivle'
  | 'setInvoiceData'
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setIsSubmitButtonLoadingAction'
  | 'setIsSubmitFailure'
  | 'setIsDisabledSubmit'
  | 'setSubmitFailInfo'
  | 'reloadStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  dataSource: [],
  isAddModalVisivle: false,
  selectedRowKeys: [],
  invoiceData: [],
  formData: {},
  isSubmitButtonLoading: false,
  isSubmitFailure: false,
  isDisabledSubmit: false,
  submitFailInfo: {},
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setIsAddModalVisivle':
      newstate.isAddModalVisivle = action.payload
      return newstate
    case 'setInvoiceData':
      newstate.invoiceData = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    case 'setIsSubmitFailure':
      newstate.isSubmitFailure = action.payload
      return newstate
    case 'setIsDisabledSubmit':
      newstate.isDisabledSubmit = action.payload
      return newstate
    case 'setSubmitFailInfo':
      newstate.submitFailInfo = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置添加订单弹窗显示
 * @param val
 * @returns
 */
export const setIsAddModalVisivle = (val: any): Action => ({
  type: 'setIsAddModalVisivle',
  payload: val,
})

/**
 * 设置当前表格数据
 * @param val
 * @returns
 */
export const setDataSource = (val: any): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置当前表格选中行
 * @param val
 * @returns
 */
export const setSelectedRowKeys = (val: any): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})

/**
 * 设置开票信息数据
 * @param val
 * @returns
 */
export const setInvoiceData = (val: any[]): Action => ({
  type: 'setInvoiceData',
  payload: val,
})
/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})

/**
 * 提交按钮防重处理
 * @param val
 * @returns
 */
export const setIsSubmitButtonLoadingAction = (val: boolean): Action => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})

/**
 * 提交失败
 * @param val
 * @returns
 */
export const setIsSubmitFailure = (val: boolean): Action => ({
  type: 'setIsSubmitFailure',
  payload: val,
})

/**
 * 禁用提交按钮
 * @param val
 * @returns
 */
export const setIsDisabledSubmit = (val: boolean): Action => ({
  type: 'setIsDisabledSubmit',
  payload: val,
})

/**
 * 提交失败提示信息
 * @param val
 * @returns
 */
export const setSubmitFailInfo = (val: {
  applyAmount?: number
  countAmount?: number
  countApplyAmount?: number
  time?: string
}): Action => ({
  type: 'setSubmitFailInfo',
  payload: val,
})

// 重载数据
export const reloadStateAction = (val: State): Action => ({
  type: 'reloadStateAction',
  payload: val,
})
